import { render, staticRenderFns } from "./LeakPositionTab.vue?vue&type=template&id=5370a2b7&scoped=true"
import script from "./LeakPositionTab.vue?vue&type=script&lang=ts"
export * from "./LeakPositionTab.vue?vue&type=script&lang=ts"
import style0 from "./LeakPositionTab.vue?vue&type=style&index=0&id=5370a2b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5370a2b7",
  null
  
)

export default component.exports